// extracted by mini-css-extract-plugin
export default {"UnderlineNavContainer":"IndexAndSearchContent-module__UnderlineNavContainer--YUZuv"};